/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delete_Transcript_TitleInputs */



/**
* | output |
* | --- |
* | "Delete Transcript" |
*
* @param {Delete_Transcript_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const delete_transcript_title = /** @type {((inputs?: Delete_Transcript_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delete_Transcript_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer la transcription")
	if (locale === "de") return /** @type {LocalizedString} */ ("Protokoll löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Elimina trascrizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить расшифровку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar transcripción")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除成绩单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トランスクリプトを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिलेख हटाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Excluir transcrição")
	return /** @type {LocalizedString} */ ("Delete Transcript")
});